<template>
<main class="is-fullheight">
<div>
  <spinner size="large" line-fg-color="#44c7f0"
    :line-size="5" class="spinner" message="Loading..." />
</div>
</main>
</template>

<script>
import Spinner from 'vue-simple-spinner'
import Accounts from '@/api/accounts'
import Widget from '@/api/widget'
import { mapMutations } from 'vuex'

export default {
  components: { Spinner },
  methods: {
    ...mapMutations('signupForm', [
      'setError'
    ])
  },
  async mounted () {
    try {
      if (this.$route.fullPath.includes('/widget')) {
        const token = this.$route.params.id
        const res = await Widget.widgetLogin(token)
        if (res.action === 'signup') {
          this.$localStorage.set('widget_token', token)
          this.$localStorage.set('profile_status', 'signup')
          this.$router.push('/signup/jobseeker/1')
        } else {
          this.$router.push('/')
        }
      } else {
        const token = this.$route.query.token
        try {
          const link = await Accounts.magic({ token })
          if (link.type === 'signup') {
            // this.$router.push('/signup/jobseeker/1')
            this.$router.push('/signup-type')
          } else {
            this.$store.dispatch('users/getUser')
            if (link.data.profile_type === 'hirer') {
              this.$router.push('/admin')
            } else {
              this.$router.push('/')
            }
          }
        } catch (error) {
          this.setError(error)
          this.$router.push('/')
        }
      }
    } catch (e) {
      this.setError(e)
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.is-fullheight {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/magic.vue